/* eslint-disable no-use-before-define */
import Chip from '@material-ui/core/Chip';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as tagActions from '../../../redux/actions/tagActions';
import { debounce } from 'throttle-debounce';
import { apiCallDebounceTime } from '../../../Constants/Api';
import { useEffect } from 'react';
import { applySelectedTagToAllAssets, removeTagFromAllAssets } from '../../../redux/actions/assetsAction';
import * as assetsAction from '../../../redux/actions/assetsAction';
import AssetsTempDrawer from '../AssetsTempDrawer';
import { Typography } from '@material-ui/core';
import { sanitizeTag } from '../../../Utils/GlobalUtils';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 700,
		'& > * + *': {
			marginTop: theme.spacing(3),
		},
		'& .MuiInputBase-root': {
			height: 'auto',
		},
	},
}));
const removeTagsTxt = 'Remove All Tags';

const RemoveAllTagsWarningDrawer = ({ open, setOpen }) => {
	const dispatch = useDispatch();
	// when Yes Btn is clicked on Warning Dialog. remove all tags from tags component and all assets.
	const handleRemoveAllTagsBtnClick = async () => {
		dispatch(tagActions.removeAllSelectedTags());
		dispatch(assetsAction.removeTagsFromAllAssets());
		setOpen(false);
	};

	const tempDrawerProps = {
		open: open,
		setOpen: setOpen,
		handleRemoveBtnClick: handleRemoveAllTagsBtnClick,
		removeMsg: removeTagsTxt,
		removeConfirmationMsg: `${removeTagsTxt} ?`,
		removeBtnTxt: 'Yes',
	};

	return <AssetsTempDrawer {...tempDrawerProps} />;
};
// Tags multi search component with Chip component render for selected tags.
const BulkMultiTagSearch = (props) => {
	const classes = useStyles();
	const options = useSelector((state) => state.tags.options);
	const optionsWithAssetTags = props.assetTags;
	const dispatch = useDispatch();
	const [displayDrawer, setDrawerDisplay] = React.useState(false);
	const onInputChange = (event, value) => {
		if (value) {
			DebounceAssetTabTagsSearch(value);
		}
	};
	//implementing debounce for tags search.
	//only trigger API call when there is a delay of mentioned time from last keystroke
	const DebounceAssetTabTagsSearch = useCallback(
		debounce(apiCallDebounceTime, false, (value) => dispatch(tagActions.loadTagsSearchData(value)).then(() => {})),
		[],
	);
	const onChange = (event, options, reason, changedDetails) => {
		if (changedDetails && reason) {
			const tag = sanitizeTag(changedDetails.option);
			// Add tag to tag search component and all assets.
			if (reason === 'select-option' || reason === 'create-option') {
				dispatch(tagActions.addSelectedTags(tag));
				dispatch(applySelectedTagToAllAssets(tag));
			} else if (reason === 'remove-option') {
				// Remove tag from tag search component and all assets.
				dispatch(tagActions.deleteSelectedTag(tag));
				dispatch(removeTagFromAllAssets(tag));
			}
		}
	};
	useEffect(() => {
		// Manually bind click event listener to clear indicator of tags autocomplete.
		const close = document.getElementsByClassName('MuiAutocomplete-clearIndicator')[0];
		close.addEventListener('click', (event) => {
			// display warning drawer when clear all icon is clicked on tags dropdown.
			setDrawerDisplay(true);
			event.stopImmediatePropagation();
		});
	}, []);
	return (
		<div className={classes.root}>
			{displayDrawer ? <RemoveAllTagsWarningDrawer open={displayDrawer} setOpen={setDrawerDisplay} /> : ''}
			<Typography variant="body1">ADD SEARCHABLE TAGS</Typography>
			<Autocomplete
				multiple
				id="add-tags"
				data-cy="add-tags"
				options={options.map((option) => {
					return option ?? '';
				})}
				value={optionsWithAssetTags}
				onInputChange={onInputChange}
				filterSelectedOptions
				onChange={onChange}
				freeSolo
				renderTags={(value, getTagProps) => {
					return value.map((option, index) => (
						<Chip variant="outlined" label={option} {...getTagProps({ index })} />
					));
				}}
				renderInput={(params) => (
					<TextField
						{...params}
						variant="outlined"
						placeholder="Tags"
						InputProps={{
							...params.InputProps,
						}}
					/>
				)}
			/>
		</div>
	);
};
export default BulkMultiTagSearch;
